import {get, post} from "../APIGateWay";
import {PAGE_LIMIT} from '../constant'

export async function getFaqs(params = {}) {
    params.page = params.page || 1;
    params.limit = params.limit || PAGE_LIMIT;
    return await get(params, '/faq/all')
}